<script>
import moment from "moment-timezone";

export default {
  name: "BufferTutorDetail",
  props:{
    task:{
      type: Object,
      default: () => {}
    }
  },
  methods:{
    formatDate(date){
      if(!date) return '';
      return moment(date).format('DD/MM/YYYY');
    }
  },
  mounted() {

  }
}
</script>

<template>
  <div class="col-md-12 px-6">
    <div
        style="border:1px solid #D6D5D5; border-radius: 5px;background-color: #F6F6F6"
        class="px-3 py-5 w-100 row"
    >
      <div class="col-md-6 mb-4">
        <p>Mã tác vụ</p>
        <el-input placeholder="-" :value="task?.id"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Phân loại </p>
        <el-input placeholder="-" :value="task?.subtype_label"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Mã lớp</p>
        <el-input placeholder="-" :value="task?.detail?.class_code"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Nội dung gia sư</p>
        <el-input placeholder="-" :value="task?.detail?.content"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Link zalo lớp đệm</p>
        <el-input placeholder="-" :value="task?.detail?.zalo_link"></el-input>
      </div>
      <div class="col-md-6 mb-4">
        <p>Trung tâm</p>
        <el-input placeholder="-" :value="task?.detail?.center_name"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Ngày làm</p>
        <el-input placeholder="-" :value="formatDate(task?.detail?.study_date)"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Thời gian bắt đầu</p>
        <el-input placeholder="-" :value="task?.detail?.start_time"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Thời gian kết thúc</p>
        <el-input placeholder="-" :value="task?.detail?.end_time"></el-input>
      </div>
    </div>
  </div>

</template>

<style scoped>

</style>